import React from "react"

import {Loading} from "../../components/Loading"
import {useUserSettingsQuery} from "../../queries/user"
import {RouterError} from "../../RouterError"
import {AUserTypes} from "../../services/types.generated"

const ALLOWED_TYPES: AUserTypes[] = [AUserTypes.CompanyUser, AUserTypes.SaasCompanyUser]

export const ReachEngineGate: React.FC<{Component: React.ComponentType}> = ({Component}) => {
  const {status, data} = useUserSettingsQuery()

  if (status === "pending") {
    return <Loading size={"xl"} />
  }
  if (status === "error") {
    return <RouterError force404 />
  }

  const allowed = ALLOWED_TYPES.includes(data.user.type) && data.reach_engine_enabled === true

  if (!allowed) {
    return <RouterError force404 />
  }
  return <Component />
}
